import axios from "axios";
import { getUrl } from "./urls";
import { getAccessToken } from "./utils.js";
import { toast } from "react-toastify";
import { formatEntityType } from "./rawDataActionUtils";
import moment from "moment";
export const FETCH_COLLECTIONS_LIST = "FETCH_COLLECTIONS_LIST";
export const FETCH_COLLECTIONS_POSTS = "FETCH_COLLECTIONS_POSTS";
export const CHANGE_TEAM_OR_OWN = "CHANGE_TEAM_OR_OWN";
export const CHANGE_COLLECTION_TYPE = "CHANGE_COLLECTION_TYPE";
export const CHANGE_COLLECTION_SORT_TYPE = "CHANGE_COLLECTION_SORT_TYPE";
export const CHANGE_COLLECTION_FILTER = "CHANGE_COLLECTION_FILTER";
export const FETCH_ALERTS_LIST = "FETCH_ALERTS_LIST";
export const ADD_TO_COLLECTION = "ADD_TO_COLLECTION";
export const BULK_ADD_TO_COLLECTION = "BULK_ADD_TO_COLLECTION";
export const TOGGLE_COLLECTION_FILTERS = "TOGGLE_COLLECTION_FILTERS";
export const UPDATE_SELECTED_FILTER_COLLECTIONS = "UPDATE_SELECTED_FILTER_COLLECTIONS";
export const DELETE_FROM_COLLECTION = "DELETE_FROM_COLLECTION";
export const BULK_DELETE_FROM_COLLECTION = "BULK_DELETE_FROM_COLLECTION";
export const UPDATE_ASSIGNED_STATUS = "UPDATE_ASSIGNED_STATUS";
export const BULK_UPDATE_ASSIGNED_STATUS = "BULK_UPDATE_ASSIGNED_STATUS";
export const SET_COVER_PHOTO = "SET_COVER_PHOTO";

export const UPDATE_CURRENT_COLLECTION = "UPDATE_CURRENT_COLLECTION";
export const REMOVE_CURRENT_COLLECTION = "REMOVE_CURRENT_COLLECTION";
export const APPLY_FILTER_COLLECTION = "APPLY_FILTER_COLLECTION";
export const RESET_CURRENT_COLLECTION_FILTER = "RESET_CURRENT_COLLECTION_FILTER";
export const UPDATE_FILTER_REFINE_SORT_COLLECTION = "UPDATE_FILTER_REFINE_SORT_COLLECTION";
export const UPDATE_CUSTOM_QUERY_COLLECTION = "UPDATE_CUSTOM_QUERY_COLLECTION";
export const DASHBOARD_UPDATE_ASSIGNED_STATUS_COLLECTION = "DASHBOARD_UPDATE_ASSIGNED_STATUS_COLLECTION";

export const updateCurrentCollection = (payload) => ({ type: UPDATE_CURRENT_COLLECTION, payload });

export const removeCurrentCollection = (payload) => ({ type: REMOVE_CURRENT_COLLECTION });

export const applyFilterCollection = (payload) => ({ type: APPLY_FILTER_COLLECTION, payload });

export const resetFilterCollection = () => ({ type: RESET_CURRENT_COLLECTION_FILTER });

export const filterRefineSortUpdateCollection = (payload) => ({ type: UPDATE_FILTER_REFINE_SORT_COLLECTION, payload });

export const updateCustomQueryCollection = (payload) => ({ type: UPDATE_CUSTOM_QUERY_COLLECTION, payload });

export const fetchCollectionsList = (arg = {}) => {
    const teamOrOwn = Object.prototype.hasOwnProperty.call(arg, "teamOrOwn") ? arg.teamOrOwn : "team";
    const collection_type = Object.prototype.hasOwnProperty.call(arg, "collection_type") ? arg.collection_type : "all";

    let data = new URLSearchParams();
    if (Object.prototype.hasOwnProperty.call(arg, "teamOrOwn")) {
        if (teamOrOwn === "team") {
            data.append("team", 1);
        } else data.append("own", 1);
    } else {
        data.append("team", 1);
        data.append("own", 1);
    }
    data.append("collection_type", collection_type);
    data.append("access-token", getAccessToken());
    const req = axios({
        method: "POST",
        url: getUrl("collection") + "/list",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => {
        return res.data;
    });

    return {
        type: FETCH_COLLECTIONS_LIST,
        payload: req,
    };
};

export const fetchCollectionsPosts = (arg) => {
    let collectionSelected = arg.collectionSelected;
    let data = getCollectionPostsUrlParams(arg.data, arg.offset, arg.sortBy, ...arg.refineOptions);
    const collections = collectionSelected.id;

    data.append("synced_collection_id", [collections]);

    const req = axios({
        method: "POST",
        url: getUrl("searchaggs"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => {
        return { ...res.data, offset: arg.offset };
    });

    return {
        type: FETCH_COLLECTIONS_POSTS,
        payload: req,
    };
};

export const handleCollectionTeamOrOwn = (arg) => {
    return {
        type: CHANGE_TEAM_OR_OWN,
        payload: arg,
    };
};

export const handleCollectionTypeChange = (arg) => {
    return {
        type: CHANGE_COLLECTION_TYPE,
        payload: arg,
    };
};

export const handleCollectionSortOptionChange = (arg) => {
    return {
        type: CHANGE_COLLECTION_SORT_TYPE,
        payload: arg,
    };
};

export const handleCollectionFilterOptionChange = (arg) => {
    return {
        type: CHANGE_COLLECTION_FILTER,
        payload: arg,
    };
};

export const deleteCollection = (arg) => {
    const collectionId = Object.prototype.hasOwnProperty.call(arg, "collectionId") ? arg.collectionId : "";
    let data = new URLSearchParams();
    data.append("collection_id", collectionId);
    data.append("access-token", getAccessToken());
    return function (dispatch) {
        axios({
            method: "POST",
            url: getUrl("collection") + "/delete",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data,
        })
            .then(() => {
                toast.success("Successfully Deleted Collection");
                dispatch(fetchCollectionsList(arg));
                dispatch(fetchAlertsList());
            })
            .catch((err) => toast.error(err));
    };
};

export const updateAssignedStatus = (arg) => {
    // console.log(arg);
    const data = {};
    data.status = arg.sync_status;
    data.current_collection_id = arg.collection.id;
    data.es_id = arg.data._id;
    data.es_index = arg.data._index;

    const req = axios({
        method: "POST",
        url: getUrl("collection") + "/changeCollectionStatus?access-token=" + getAccessToken(),
        headers: {
            "Content-Type": "application/json",
        },
        data,
    })
        .then((res) => {
            toast.success("Updated assigned status");
            return { ...res.data, collection: arg.collection.id, id: arg.data._id, sync_status: arg.sync_status };
        })
        .catch((error) => {
            toast.error(error.response.data.message);
        });

    return {
        type: UPDATE_ASSIGNED_STATUS,
        payload: req,
    };
};

export const bulkUpdateAssignedStatus = (arg) => {
    // console.log(arg)
    let promises = [];

    arg.ids.forEach((id) => {
        const [es_index, es_id] = id.split(":");
        let data = {};
        data.status = arg.sync_status;
        data.current_collection_id = arg.collection_id;
        data.es_id = es_id;
        data.es_index = es_index;

        let req = axios({
            method: "post",
            url: getUrl("collection") + "/changeCollectionStatus?access-token=" + getAccessToken(),
            headers: {
                "Content-Type": "application/json",
            },
            data,
        })
            .then((res) => res.data)
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        promises.push(req);
    }, this);
    return (dispatch) => {
        let req = Promise.all(promises).then(() => {
            setTimeout(() => dispatch(fetchCollectionsPosts(arg.data)), 1000);
        });
        return {
            type: BULK_UPDATE_ASSIGNED_STATUS,
            payload: req,
        };
    };
};

export const createCollection = (arg) => {
    let data = {};
    if (arg.visibility === "team") {
        data.access_type = "2";
        data.access_value = arg.teams.map((t) => t.value).toString();
    }
    if (arg.visibility === "own") {
        data.access_type = "0";
        data.access_value = "";
    }
    let alertMessage = "";
    if (arg.alerts.length > 0) {
        data.alert_ids = arg.alertIds;
        data.collection_type = "synced";
        enableOrDisableAlert(arg.alerts);
        alertMessage = arg.alerts.map((a) => a.label).join(",");
        alertMessage = "Collection successfully created";
    } else {
        data.collection_type = "basic";
        alertMessage = "Collection successfully created";
    }

    data.name = arg.title;
    data.tags = arg.tags;

    return function (dispatch) {
        axios({
            method: "POST",
            url: getUrl("collection") + "/create?access-token=" + getAccessToken(),
            headers: {
                "Content-Type": "application/json",
            },
            data,
        })
            .then(() => {
                console.log(arg);
                toast.success(alertMessage);
                dispatch(fetchCollectionsList(arg));
                dispatch(fetchAlertsList());
            })
            .catch((err) => {
                const msg = err.response.data.message;
                if (msg === "A collection with this name is already created" || msg === "A synced collection with this name is already created")
                    toast.error("A Collection with this name already exists");
                else
                    toast.error(
                        "Error. We were unable to complete your request. Please try again. If you are still unable to create a desired Collection, please get in touch with your Radarr representative.",
                    );
            });
    };
};

export const editCollection = (arg) => {
    let data = {};
    // console.log(arg);
    if (arg.initialValue === "tags") {
        data.tags = arg.tags;
    } else {
        if (arg.initialValue.access_type !== "0" && arg.visibility === "own") {
            data.access_type = "0";
            data.access_value = "";
        } else if (arg.visibility === "team") {
            let is_same =
                arg.teams.length == arg.initialValue.team_details.length &&
                arg.teams.every((element, index) => {
                    return element.id === arg.initialValue.team_details[index].id;
                });
            if (arg.initialValue.access_type !== "2") data.access_type = "2";
            if (!is_same) {
                data.access_value = arg.teams.map((t) => t.value).toString();
            }
        }
        if (arg.alerts.length > 0) {
            data.alert_ids = arg.alertIds;
            data.collection_type = "synced";
            enableOrDisableAlert(arg.alerts);
        } else {
            data.collection_type = "basic";
            data.alert_ids = [];
        }
        if (arg.initialValue.name !== arg.title) data.name = arg.title;
        if (arg.initialValue.tags !== arg.tags) data.tags = arg.tags;
    }
    data.collection_id = arg.id;

    return function (dispatch) {
        return axios({
            method: "POST",
            url: getUrl("collection") + "/update?access-token=" + getAccessToken(),
            headers: {
                "Content-Type": "application/json",
            },
            data,
        })
            .then((res) => {
                toast.success("Collection has been updated successfully");
                setTimeout(() => {
                    dispatch(fetchCollectionsList(arg));
                    dispatch(fetchAlertsList());
                }, 1000);
                return res;
            })
            .catch((err) => {
                const msg = err.response.data.message;
                if (msg === "colection with given name is already created") toast.error("A Collection with this name already exists");
                else toast.error(msg);
                return err.response;
            });
    };
};

export const enableOrDisableAlert = (alerts) => {
    const alertsToBeUpdated = alerts.filter((a) => {
        if (a) return a.oldDisabled !== a.disabled;
        else return false;
    });
    if (alertsToBeUpdated.length > 0)
        alertsToBeUpdated.map((a) => {
            axios({
                method: "POST",
                url: getUrl("alerts") + "/enableOrDisable?access-token=" + getAccessToken(),
                headers: {
                    "Content-Type": "application/json",
                },
                data: {
                    alert_id: a.value,
                    action: a.disabled ? "disable" : "enable",
                },
            })
                .then(() => {
                    // console.log("updated alert");
                })
                .catch((err) => toast.error(err));
        });
};

export function addToCollection(postid, coll) {
    // console.log(coll);
    let data = new URLSearchParams();
    data.append("_id", postid);
    if (coll.tags) data.append("tags", coll.tags);
    if (coll.newColl) {
        data.append("name", coll.name);
        if (coll.type == "own") {
            data.append("access_type", 0);
        } else {
            data.append("access_type", 2);
            data.append("access_value", coll.teams.map((t) => t.value).join(","));
        }
    } else {
        data.append("collection_id", coll.id);
    }

    data.append("access-token", getAccessToken());
    let req = axios({
        method: "post",
        url: getUrl("collection") + "/create",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    })
        .then((res) => {
            toast.success("Post has been added to Collection");
            return res.data;
        })
        .catch((error) => {
            toast.error(error.response.data.message);
        });
    return {
        type: ADD_TO_COLLECTION,
        payload: req,
    };
}

export function bulkCollectionAdd(ids, collId) {
    let data = {
        _ids: ids.join(","),
        "synced_collections.add": collId,
    };

    let req = axios
        .post(`${getUrl("elastisearch_service")}/update-es-post?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        })
        .then((res) => {
            toast.success("All the selected posts have been added successfully to the Collection");
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("Some error occurred while processing your request");
        });
    return {
        type: BULK_ADD_TO_COLLECTION,
        payload: req,
    };
}

export const fetchAlertsList = () => {
    const req = axios({
        method: "GET",
        url: getUrl("alerts") + "/list?access-token=" + getAccessToken(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((res) => {
            // console.log(res.data);
            return res.data;
        })
        .catch((err) => console.log(err));

    return {
        type: FETCH_ALERTS_LIST,
        payload: req,
    };
};

export const toggleCollectionFilterShow = () => {
    return {
        type: TOGGLE_COLLECTION_FILTERS,
    };
};

export const updateSelectedFilterCollections = (val) => {
    return {
        type: UPDATE_SELECTED_FILTER_COLLECTIONS,
        payload: val,
    };
};

export const getCollectionPostsUrlParams = (
    data,
    offset,
    sortOption,
    influencers,
    sentiment,
    sentimentType,
    contentSafety,
    contentSafetyType,
    media,
    channel,
    // grouping,
    postType,
    exclusion,
    sampling,
    reviewStatus = "opened",
    ext,
) => {
    let params = new URLSearchParams();

    data.languages && params.append("language", data.languages);
    data.countries && params.append("location", data.countries);
    data.platforms && params.append("platform", data.platforms);

    // duration
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (data.graph && data.graph === "GAUGE") {
        params.append("start_date", moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss"));
        params.append("end_date", moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss"));
    } else if (data.duration === "custom") {
        params.append("start_date", moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss"));
        params.append("end_date", moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss"));
    } else if (data.duration === "24HRS") {
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss"));
        params.append("start_date", moment(new Date()).tz(tz).subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss"));
    } else {
        params.append("duration", data.duration);
    }

    if (data.duration === "custom" && data.rollingDate) {
        params.delete("end_date");
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss"));
    }

    params.append("data", 1);

    // entity type
    if (data.entityType !== "all" && data.entityType && data.entityType !== "") {
        formatEntityType(params, data.entityType, data.entitySubType);
    }

    // sort option
    if (sortOption === "published_date_desc") {
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
    } else if (sortOption === "published_date_asc") {
        params.append("orderBy", "post.published_date");
        params.append("order", "asc");
    } else if (sortOption === "impact_prediction_score") {
        params.append("orderBy", "impact_prediction_score");
    } else if (sortOption === "trending_now_virality") {
        params.append("virality_parameter", 0);
        params.append("orderBy", "impact_value");
    } else if (sortOption === "predicted_virality") {
        params.append("virality_parameter", 1);
        params.append("orderBy", "impact_prediction_score");
    } else params.append("orderBy", sortOption);

    if (!ext) params.append("offset", offset);
    params.append("recordsPerPage", 50);

    // refine filter
    if (sentiment !== "ALL") params.append("sentiment", sentiment);
    if (sentimentType !== "ALL") params.append("sentiment_source", sentimentType);
    if (contentSafety !== "sfw") params.append("content_safety", contentSafety);
    if (contentSafetyType !== "ALL") params.append("content_safety_source", contentSafetyType);
    if (media !== "ALL") params.append("post_media_type", media);

    if (channel !== "ALL") params.append("source_type", channel);

    // if (grouping !== "ALL") params.append("post_type", grouping);
    if (postType !== "ALL") params.append("post_type", postType);

    if (data.custom_query && data.custom_query !== "") {
        params.append("custom_query", data.custom_query);
    }
    if (data.tag_category_ids) {
        params.append("tag_category_ids", data.tag_category_ids);
    }

    if (reviewStatus) params.append("synced_collection_status", reviewStatus);

    if (sampling && sampling != 100) {
        params.set("orderBy", "rand");
        params.set("sampling_value", sampling);
    }

    const influencer_type_filter = JSON.parse(localStorage.getItem("influencer_type_filter"));
    if (influencer_type_filter && influencers && influencers.length) {
        if (influencers[0] !== "all") params.set("influencer_types", influencers.join(","));
        else {
            // const influencersList = JSON.parse(localStorage.getItem("influencersList"))
            // params.set("influencer_types", influencersList.map(i => i.name).join(","));
        }
    }

    if (data.selected_fields) {
        params.set("selected_fields", data.selected_fields);
    }

    if (ext) {
        params.append("download_type", ext);
        params.append("download_name", "unified/collections");
    }

    return params;
};

export const deletePostFromCollection = (arg) => {
    let data = new URLSearchParams();
    data.append("collection_id", +arg.collection_id);
    data.append("es_id", arg.es_id);
    data.append("es_index", arg.es_index);
    data.append("access-token", getAccessToken());

    let req = axios({
        method: "post",
        url: getUrl("collection") + "/deletePostFromCollection",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    })
        .then((res) => {
            toast.success("Successfully deleted post from the Collection");
            return res.data;
        })
        .catch((error) => {
            toast.error(error.response.data.message);
        });
    return {
        type: DELETE_FROM_COLLECTION,
        payload: req,
    };
};

export function bulkDeleteFromCollection(arg) {
    let promises = [];

    arg.ids.forEach((id) => {
        const [es_index, es_id] = id.split(":");
        let data = new URLSearchParams();
        data.append("collection_id", +arg.collection_id);
        data.append("es_id", es_id);
        data.append("es_index", es_index);
        data.append("access-token", getAccessToken());

        let req = axios({
            method: "post",
            url: getUrl("collection") + "/deletePostFromCollection",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data,
        })
            .then((res) => res.data)
            .catch((error) => {
                toast.error(error.response.data.message);
            });

        promises.push(req);
    }, this);
    return (dispatch) => {
        let req = Promise.all(promises).then(() => {
            setTimeout(() => dispatch(fetchCollectionsPosts(arg.data)), 1000);
        });
        return {
            type: BULK_DELETE_FROM_COLLECTION,
            payload: req,
        };
    };
}

export function bulkUpdateAssigndStatus(arg) {
    let promises = [];

    arg.ids.forEach((id) => {
        const [es_index, es_id] = id.split(":");
        let data = {};
        data.status = arg.sync_status;
        data.current_collection_id = arg.collection_id;
        data.es_id = es_id;
        data.es_index = es_index;

        let req = axios({
            method: "post",
            url: getUrl("collection") + "/changeCollectionStatus?access-token=" + getAccessToken(),
            headers: {
                "Content-Type": "application/json",
            },
            data,
        })
            .then((res) => res.data)
            .catch((error) => {
                toast.error(error.response.data.message);
            });

        promises.push(req);
    });

    let req = Promise.all(promises);

    return function (dispatch) {
        dispatch({
            type: "DASHBOARD_UPDATE_ASSIGNED_STATUS_COLLECTION_PENDING",
        });
        req.then(() => {
            toast.success("Updated assigned status for all selected posts from Collection");
            setTimeout(() => dispatch({ type: "DASHBOARD_UPDATE_ASSIGNED_STATUS_COLLECTION_FULFILLED" }), 1000);
        }).catch((err) => {
            toast.error("Failed to updated assigned status for all selected posts from Collection");
            console.log(err);
            dispatch({
                type: "DASHBOARD_UPDATE_ASSIGNED_STATUS_COLLECTION_REJECTED",
            });
        });
    };
}

export const setCoverPhoto = (arg) => {
    let data = {};
    data.collection_id = arg.id;
    data.post_image = { server: arg.data.server, folder: arg.data.folder, name: arg.data.name };

    const req = axios({
        method: "POST",
        url: getUrl("collection") + "/setcoverPhoto?access-token=" + getAccessToken(),
        headers: {
            "Content-Type": "application/json",
        },
        data,
    }).then((res) => {
        return res.data;
    });

    return {
        type: SET_COVER_PHOTO,
        payload: req,
    };
};

export function downloadCollectionPosts(arg) {
    let collectionSelected = arg.collectionSelected;
    let data = getCollectionPostsUrlParams(arg.data, arg.offset, arg.sortBy, ...arg.refineOptions, arg.ext);
    const collections = collectionSelected.id;

    data.append("synced_collection_id", [collections]);
    data.append("access-token", getAccessToken());
    // console.log(data);
    return function (dispatch) {
        axios
            .post(getUrl("download"), data, { "Content-Type": "application/x-www-form-urlencoded" })
            .then((response) => {
                toast.success("Your Download request has been received and you will shortly receive an email with the Download link.");
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
                else toast.error("Some error occurred while processing your request");
            });
    };
}
